<template>
    <div class="section">
        <app-loader :loading="getLoaderStatus"
                    :color="options.color"
                    :size="options.size" />
        <div class="columns" v-if="!getLoaderStatus">
            <right-side :lot="getLot"></right-side>
            <left-side :lot="getLot"></left-side>
        </div>
    </div>
</template>

<script>
    import appLoader from 'vue-spinner/src/ClipLoader'
    import leftSide from './LeftSide'
    import rightSide from './RightSide'
    export default {
        components: {
            leftSide: leftSide,
            rightSide: rightSide,
            appLoader: appLoader
        },
        data() {
            return {
                options: this.$store.getters.getOptions
            }
        },
        computed: {
            getLoaderStatus() {
                return this.$store.getters.getLoaderStatus
            },
            getLot() {
                return this.$store.getters.getSingleLot
            }
        },
        created() {
            this.$store.dispatch('fetchSingleLotData', this.$route.params.id)
        }
    }
</script>

<style scoped>
    .section {
        padding: 60px 0 0;
    }
    .columns {
        margin-left: 0;
        margin-right: 0;
    }
    .columns >>> .card-content {
        padding: 0.8em 0.6em;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Lot/Lot.vue